import React, { useCallback, useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { Outlet } from "react-router-dom";
import { useAppDispatch } from "../store/configureStore";
import { fetchCurrentUser } from "../pages/account/accountSlice";

const Layout = ({ children }: any) => {
  const dispatch = useAppDispatch();
  const initApp = useCallback(async () => {
    try {
      await dispatch(fetchCurrentUser());
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    initApp();
  }, [initApp]);

  //expire login session after a period of time
  useEffect(() => {
    const storedTimestamp = localStorage.getItem("timestamp");
    const phoneNumber = localStorage.getItem("phonenumber");

    if (phoneNumber && storedTimestamp) {
      const expirationTime = 24 * 60 * 60 * 1000;
      const currentTime = new Date().getTime();
      const storedTime = new Date(storedTimestamp).getTime();

      if (currentTime - storedTime < expirationTime) return;
      const keepPrefix = "pdf_highlights_";
      const keptEntries: Record<string, string> = {};

      // Step 1: Collect all highlight keys and values
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith(keepPrefix)) {
          const value = localStorage.getItem(key);
          if (value !== null) {
            keptEntries[key] = value;
          }
        }
      }

      // Step 2: Clear everything
      localStorage.clear();

      // Step 3: Restore the highlights
      Object.entries(keptEntries).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });
      window.location.reload();
    }
  }, []);
  return (
    <React.Fragment>
      <Header />
      <Outlet />
      {children}
      <Footer />
    </React.Fragment>
  );
};

export default Layout;
